import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=203dbced&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=203dbced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203dbced",
  null
  
)

export default component.exports